"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function () { return ({
    action: 'heartbeat',
    msgId: virtual.msgId
}); }; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/heartbeat.ts